import { WorkOutlineOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { roleSpecialtyLabel, RoleSpecialtyOption, TagsList } from 'shared/components';
import { EntityViewBlock, EntityViewContentValueRow, EntityViewSectionTitle } from 'shared/components/layout/entityView';
import { EmptyPlaceholder } from 'shared/components/layout/entityView/EmptyPlaceholder';
import { useFeatureEnabled } from 'shared/hooks';

export interface ProfessionalDetailsSectionProps {
    roles: Array<{ name: string }>;
    roleSpecialties: RoleSpecialtyOption[];
    skills: Array<{ name: string }>;
}

export default function ProfessionalDetailsSection({ roles, roleSpecialties, skills }: ProfessionalDetailsSectionProps) {
    const { t } = useTranslation('profile');
    const isRoleSpecialtyEnabled = useFeatureEnabled('RoleSpecialtyTaxonomy');

    // When the flag is off, show the plain role names; otherwise the (role, speciality) pair labels.
    const roleTags = isRoleSpecialtyEnabled
        ? roleSpecialties.map(v => roleSpecialtyLabel(v, t))
        : roles.map(r => r.name);

    return (
        <>
            <EntityViewSectionTitle
                title={ t('view.sections.professionalDetails') }
                icon={ <WorkOutlineOutlined /> }
            />

            <EntityViewBlock title={ t(isRoleSpecialtyEnabled ? 'fields.rolesSpecialties' : 'fields.roles') }>
                <EntityViewContentValueRow>
                    { roleTags.length > 0
                        ? <TagsList tags={ roleTags } />
                        : <EmptyPlaceholder /> }
                </EntityViewContentValueRow>
            </EntityViewBlock>

            <EntityViewBlock title={ t('fields.skills') }>
                <EntityViewContentValueRow>
                    { skills.length > 0
                        ? <TagsList tags={ skills.map(r => r.name) } />
                        : <EmptyPlaceholder /> }
                </EntityViewContentValueRow>
            </EntityViewBlock>
        </>
    );
}
